import { render } from "./AppAccount.vue?vue&type=template&id=655f98ae&ts=true"
import script from "./AppAccount.vue?vue&type=script&lang=ts"
export * from "./AppAccount.vue?vue&type=script&lang=ts"

import exportComponent from "/home/mateusz/Workspace/Planer Ślubu/planer-slubu-mcs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__